var _path, _g, _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25V11C1.28853e-07 9.89543 0.895431 9 2 9H10C11.1046 9 12 9.89543 12 11V19C12 20.1046 11.1046 21 10 21H4L0 25Z",
    fill: "#5E5CE6"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -22.5,
    y: -29.5,
    width: 77,
    height: 81.7072
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_0_6_1634_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 30
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17H10C8.89543 17 8 16.1046 8 15V3C8 1.89543 8.89543 1 10 1H22C23.1046 1 24 1.89543 24 3V21L20 17Z",
    fill: "#282828",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0.75C23.2426 0.75 24.25 1.75736 24.25 3V21.6035L19.8965 17.25H10C8.75736 17.25 7.75 16.2426 7.75 15V3C7.75 1.75736 8.75736 0.75 10 0.75H22Z",
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 0.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 1,
    fill: "#5E5CE6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9,
    r: 1,
    fill: "#5E5CE6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 9,
    r: 1,
    fill: "#5E5CE6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_6_1634_clip_path",
    transform: "translate(22.5 29.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17H10C8.89543 17 8 16.1046 8 15V3C8 1.89543 8.89543 1 10 1H22C23.1046 1 24 1.89543 24 3V21L20 17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSupport);
export default __webpack_public_path__ + "static/media/smallSupport.2526cfed4d311d75dbe290ed0ddfd95f.svg";
export { ForwardRef as ReactComponent };